export default __webpack_public_path__ + "media/images/xero-7df634d89b997da93f4f5a162f6ce690.png";